export default function rotate(rotation, Dispatcher, Store) {
  Dispatcher.dispatch({
    type: 'ROTATION_UPDATE',
    rotation,
  });
}
